import React, { createContext, useContext, useState, ReactNode } from 'react';
import { CategoryInterface } from '../assets/interfaces/FX_POS_Interfaces';

interface CatPropsData {
  selectedCategory: CategoryInterface | null;
  setSelectedCategory: (cat: CategoryInterface | null) => void;
}

const CategoryContext = createContext<CatPropsData | undefined>(undefined);

export const useCategory = () => {
  const context = useContext(CategoryContext);
  if (context === undefined) {
    throw new Error('useCategory must be used within a CategoryProvider');
  }
  return context;
};

interface CategoryProviderProps {
  children: ReactNode;
}

export const CategoryProvider: React.FC<CategoryProviderProps> = ({ children }) => {
  const [selectedCategory, setSelectedCategory] = useState<CategoryInterface | null>(null);

  return (
    <CategoryContext.Provider value={{ selectedCategory, setSelectedCategory }}>
      {children}
    </CategoryContext.Provider>
  );
};
